// extracted by mini-css-extract-plugin
module.exports = {"card":"PopupScreen_card__O9wc4","cardHead":"PopupScreen_cardHead__3-Id_","button":"PopupScreen_button__27T-J","closeButton":"PopupScreen_closeButton__CjUCL"};